export default __webpack_public_path__ + "static/media/gutargu3.e83e0dee.PNG";